import {
  CreditLineTransaction,
  ManualBalanceTransaction,
  Order,
  Reference,
  ReferenceType,
  Refund,
  Type,
} from '../lib/types/AccountTransaction'
import { Gender } from '../lib/types'

export const isMale = (gender: Gender): boolean => {
  return gender === 'male'
}

export const isOrder = (
  reference: Reference,
  type: ReferenceType
): reference is Order => {
  return type === 'Order'
}

export const isManual = (
  reference: Reference,
  type: ReferenceType
): reference is ManualBalanceTransaction => {
  return type === 'ManualBalanceTransaction'
}

export const isCommentable = (
  reference: Reference,
  type: ReferenceType
): reference is ManualBalanceTransaction | Refund | CreditLineTransaction => {
  return [
    'ManualBalanceTransaction',
    'Refund',
    'CreditLineTransaction',
  ].includes(type)
}

export const isDebit = (operation: Type): boolean => {
  return operation === 'debit'
}

export const isLoggable = (type: ReferenceType): boolean => {
  return ['ManualBalanceTransaction', 'Refund'].includes(type)
}
